const obscureString = (string: string, symbol: string = '*'): string => {
  const length = string.length
  if (length > 4) {
    return `${string.substr(0, 1)}${string.substr(1, length - 1).replace(/\w/g, symbol)}${string.substr(-1, 1)}`
  }
  return string.replace(/\w/g, symbol)
}

export default obscureString
